import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'kiene-mobile-page-header',
    templateUrl: './mobile-page-header.component.html',
    styleUrls: ['./mobile-page-header.component.scss'],
})
export class MobilePageHeaderComponent {
    @Input() ueberschrift = '';
    @Input() showReturnButton = true;
    @Input() small = false;
    @Input() titleOffsetTopPx = 0;
    @Input() routeRelativeAlternative?: string;

    /** When subscribed, replaces default history/route back navigation. */
    @Output() backClick = new EventEmitter<void>();

    constructor(
        private readonly router: Router,
        private readonly route: ActivatedRoute,
    ) {}

    goBack(): void {
        if (this.backClick.observed) {
            this.backClick.emit();
            return;
        }
        if (this.routeRelativeAlternative) {
            this.router.navigate([this.routeRelativeAlternative], { relativeTo: this.route }).then();
            return;
        }
        window.history.back();
    }
}
